export default {"src":"/_next/static/media/ui-path-logo.d813fd4b.svg","height":32,"width":94,"blurWidth":0,"blurHeight":0};